// -------------------------------------------------------------------------------

// PLEASE DO NOT EDIT THIS FILE, IT IS GENERATED AND WILL BE OVERWRITTEN:
// https://github.com/ccxt/ccxt/blob/master/CONTRIBUTING.md#how-to-contribute-code

// -------------------------------------------------------------------------------

import { Dict, List } from '../base/types.js';
import { Exchange as _Exchange } from '../base/Exchange.js';

interface Exchange {
    spotPublicGetAnnouncements (params?: {}): Promise<Dict>;
    spotPublicGetPing (params?: {}): Promise<Dict>;
    spotPublicGetTime (params?: {}): Promise<Dict>;
    spotPublicGetDefaultSymbols (params?: {}): Promise<Dict>;
    spotPublicGetSymbolOffline (params?: {}): Promise<Dict>;
    spotPublicGetExchangeInfo (params?: {}): Promise<Dict>;
    spotPublicGetDepth (params?: {}): Promise<Dict>;
    spotPublicGetTrades (params?: {}): Promise<List>;
    spotPublicGetHistoricalTrades (params?: {}): Promise<List>;
    spotPublicGetAggTrades (params?: {}): Promise<List>;
    spotPublicGetKlines (params?: {}): Promise<List>;
    spotPublicGetAvgPrice (params?: {}): Promise<Dict>;
    spotPublicGetTicker24hr (params?: {}): Promise<Dict | List>;
    spotPublicGetTickerPrice (params?: {}): Promise<Dict>;
    spotPublicGetTickerBookTicker (params?: {}): Promise<List>;
    spotPublicGetEtfInfo (params?: {}): Promise<Dict>;
    spotPrivateGetKycStatus (params?: {}): Promise<Dict>;
    spotPrivateGetUid (params?: {}): Promise<Dict>;
    spotPrivateGetApiKeyInfo (params?: {}): Promise<Dict>;
    spotPrivateGetOrder (params?: {}): Promise<Dict>;
    spotPrivateGetOpenOrders (params?: {}): Promise<List>;
    spotPrivateGetAllOrders (params?: {}): Promise<List>;
    spotPrivateGetAccount (params?: {}): Promise<Dict>;
    spotPrivateGetMyTrades (params?: {}): Promise<List>;
    spotPrivateGetStrategyGroup (params?: {}): Promise<Dict>;
    spotPrivateGetStrategyGroupUid (params?: {}): Promise<Dict>;
    spotPrivateGetTradeFee (params?: {}): Promise<Dict>;
    spotPrivateGetSubAccountList (params?: {}): Promise<Dict>;
    spotPrivateGetSubAccountApiKey (params?: {}): Promise<Dict>;
    spotPrivateGetSubAccountAsset (params?: {}): Promise<Dict>;
    spotPrivateGetCapitalConfigGetall (params?: {}): Promise<List>;
    spotPrivateGetCapitalDepositHisrec (params?: {}): Promise<List>;
    spotPrivateGetCapitalWithdrawHistory (params?: {}): Promise<List>;
    spotPrivateGetCapitalWithdrawAddress (params?: {}): Promise<Dict>;
    spotPrivateGetCapitalDepositAddress (params?: {}): Promise<List>;
    spotPrivateGetCapitalTransfer (params?: {}): Promise<Dict>;
    spotPrivateGetCapitalTransferTranId (params?: {}): Promise<Dict>;
    spotPrivateGetCapitalTransferInternal (params?: {}): Promise<Dict>;
    spotPrivateGetCapitalSubAccountUniversalTransfer (params?: {}): Promise<Dict>;
    spotPrivateGetCapitalConvert (params?: {}): Promise<Dict>;
    spotPrivateGetCapitalConvertList (params?: {}): Promise<List>;
    spotPrivateGetMarginLoan (params?: {}): Promise<Dict>;
    spotPrivateGetMarginAllOrders (params?: {}): Promise<Dict>;
    spotPrivateGetMarginMyTrades (params?: {}): Promise<Dict>;
    spotPrivateGetMarginOpenOrders (params?: {}): Promise<List>;
    spotPrivateGetMarginMaxTransferable (params?: {}): Promise<Dict>;
    spotPrivateGetMarginPriceIndex (params?: {}): Promise<Dict>;
    spotPrivateGetMarginOrder (params?: {}): Promise<Dict>;
    spotPrivateGetMarginIsolatedAccount (params?: {}): Promise<Dict>;
    spotPrivateGetMarginMaxBorrowable (params?: {}): Promise<Dict>;
    spotPrivateGetMarginRepay (params?: {}): Promise<Dict>;
    spotPrivateGetMarginIsolatedPair (params?: {}): Promise<Dict>;
    spotPrivateGetMarginForceLiquidationRec (params?: {}): Promise<Dict>;
    spotPrivateGetMarginIsolatedMarginData (params?: {}): Promise<Dict>;
    spotPrivateGetMarginIsolatedMarginTier (params?: {}): Promise<Dict>;
    spotPrivateGetRebateTaxQuery (params?: {}): Promise<Dict>;
    spotPrivateGetRebateDetail (params?: {}): Promise<Dict>;
    spotPrivateGetRebateDetailKickback (params?: {}): Promise<Dict>;
    spotPrivateGetRebateReferCode (params?: {}): Promise<Dict>;
    spotPrivateGetRebateAffiliateCommission (params?: {}): Promise<Dict>;
    spotPrivateGetRebateAffiliateWithdraw (params?: {}): Promise<Dict>;
    spotPrivateGetRebateAffiliateCommissionDetail (params?: {}): Promise<Dict>;
    spotPrivateGetRebateAffiliateCampaign (params?: {}): Promise<Dict>;
    spotPrivateGetRebateAffiliateReferral (params?: {}): Promise<Dict>;
    spotPrivateGetRebateAffiliateSubaffiliates (params?: {}): Promise<Dict>;
    spotPrivateGetRebateAffiliateList (params?: {}): Promise<Dict>;
    spotPrivateGetMxDeductEnable (params?: {}): Promise<Dict>;
    spotPrivateGetUserDataStream (params?: {}): Promise<Dict>;
    spotPrivateGetSelfSymbols (params?: {}): Promise<Dict>;
    spotPrivateGetAssetInternalTransferRecord (params?: {}): Promise<Dict>;
    spotPrivatePostOrder (params?: {}): Promise<Dict>;
    spotPrivatePostOrderTest (params?: {}): Promise<Dict>;
    spotPrivatePostApiKeyInfo (params?: {}): Promise<Dict>;
    spotPrivatePostSubAccountVirtualSubAccount (params?: {}): Promise<Dict>;
    spotPrivatePostSubAccountApiKey (params?: {}): Promise<Dict>;
    spotPrivatePostSubAccountFutures (params?: {}): Promise<Dict>;
    spotPrivatePostSubAccountMargin (params?: {}): Promise<Dict>;
    spotPrivatePostBatchOrders (params?: {}): Promise<List>;
    spotPrivatePostStrategyGroup (params?: {}): Promise<Dict>;
    spotPrivatePostStrategyGroupUid (params?: {}): Promise<Dict>;
    spotPrivatePostCapitalWithdrawApply (params?: {}): Promise<Dict>;
    spotPrivatePostCapitalWithdraw (params?: {}): Promise<Dict>;
    spotPrivatePostCapitalTransfer (params?: {}): Promise<Dict>;
    spotPrivatePostCapitalTransferInternal (params?: {}): Promise<Dict>;
    spotPrivatePostCapitalDepositAddress (params?: {}): Promise<Dict>;
    spotPrivatePostCapitalSubAccountUniversalTransfer (params?: {}): Promise<Dict>;
    spotPrivatePostCapitalConvert (params?: {}): Promise<Dict>;
    spotPrivatePostMxDeductEnable (params?: {}): Promise<Dict>;
    spotPrivatePostUserDataStream (params?: {}): Promise<Dict>;
    spotPrivatePutUserDataStream (params?: {}): Promise<Dict>;
    spotPrivateDeleteOrder (params?: {}): Promise<List>;
    spotPrivateDeleteOpenOrders (params?: {}): Promise<Dict>;
    spotPrivateDeleteOrderAll (params?: {}): Promise<Dict>;
    spotPrivateDeleteSubAccountApiKey (params?: {}): Promise<Dict>;
    spotPrivateDeleteStrategyGroup (params?: {}): Promise<Dict>;
    spotPrivateDeleteStrategyGroupUid (params?: {}): Promise<Dict>;
    spotPrivateDeleteMarginOrder (params?: {}): Promise<List>;
    spotPrivateDeleteMarginOpenOrders (params?: {}): Promise<Dict>;
    spotPrivateDeleteUserDataStream (params?: {}): Promise<Dict>;
    spotPrivateDeleteCapitalWithdraw (params?: {}): Promise<Dict>;
    contractPublicGetPing (params?: {}): Promise<Dict>;
    contractPublicGetDetail (params?: {}): Promise<Dict>;
    contractPublicGetSupportCurrencies (params?: {}): Promise<Dict>;
    contractPublicGetDepthSymbol (params?: {}): Promise<Dict>;
    contractPublicGetDepthCommitsSymbolLimit (params?: {}): Promise<Dict>;
    contractPublicGetIndexPriceSymbol (params?: {}): Promise<Dict>;
    contractPublicGetFairPriceSymbol (params?: {}): Promise<Dict>;
    contractPublicGetFundingRateSymbol (params?: {}): Promise<Dict>;
    contractPublicGetKlineSymbol (params?: {}): Promise<Dict>;
    contractPublicGetKlineIndexPriceSymbol (params?: {}): Promise<Dict>;
    contractPublicGetKlineFairPriceSymbol (params?: {}): Promise<Dict>;
    contractPublicGetDealsSymbol (params?: {}): Promise<Dict>;
    contractPublicGetTicker (params?: {}): Promise<Dict>;
    contractPublicGetRiskReverse (params?: {}): Promise<Dict>;
    contractPublicGetRiskReverseHistory (params?: {}): Promise<Dict>;
    contractPublicGetFundingRateHistory (params?: {}): Promise<Dict>;
    contractPrivateGetAccountAssets (params?: {}): Promise<Dict>;
    contractPrivateGetAccountAssetCurrency (params?: {}): Promise<Dict>;
    contractPrivateGetAccountTransferRecord (params?: {}): Promise<Dict>;
    contractPrivateGetAccountProfitRateType (params?: {}): Promise<Dict>;
    contractPrivateGetAccountAssetAnalysisType (params?: {}): Promise<Dict>;
    contractPrivateGetAccountFeeDeductConfigs (params?: {}): Promise<Dict>;
    contractPrivateGetAccountAssetAnalysisYesterdayPnl (params?: {}): Promise<Dict>;
    contractPrivateGetAccountAssetAnalysisTodayPnl (params?: {}): Promise<Dict>;
    contractPrivateGetAccountConfigContractFeeDiscountConfig (params?: {}): Promise<Dict>;
    contractPrivateGetOrderFeeDetails (params?: {}): Promise<Dict>;
    contractPrivateGetAccountDiscountType (params?: {}): Promise<Dict>;
    contractPrivateGetAccountAssetAnalysisExport (params?: {}): Promise<Dict>;
    contractPrivateGetAccountAssetBookOrderDealFeeTotal (params?: {}): Promise<Dict>;
    contractPrivateGetAccountContractFeeRate (params?: {}): Promise<Dict>;
    contractPrivateGetAccountContractZeroFeeRate (params?: {}): Promise<Dict>;
    contractPrivateGetPositionListHistoryPositions (params?: {}): Promise<Dict>;
    contractPrivateGetPositionOpenPositions (params?: {}): Promise<Dict>;
    contractPrivateGetPositionFundingRecords (params?: {}): Promise<Dict>;
    contractPrivateGetPositionPositionMode (params?: {}): Promise<Dict>;
    contractPrivateGetOrderListOpenOrdersSymbol (params?: {}): Promise<Dict>;
    contractPrivateGetOrderListOpenOrders (params?: {}): Promise<Dict>;
    contractPrivateGetOrderListHistoryOrders (params?: {}): Promise<Dict>;
    contractPrivateGetOrderListOrderDealsV3 (params?: {}): Promise<Dict>;
    contractPrivateGetOrderExternalSymbolExternalOid (params?: {}): Promise<Dict>;
    contractPrivateGetOrderGetOrderId (params?: {}): Promise<Dict>;
    contractPrivateGetOrderBatchQuery (params?: {}): Promise<Dict>;
    contractPrivateGetOrderDealDetailsOrderId (params?: {}): Promise<Dict>;
    contractPrivateGetOrderListOrderDeals (params?: {}): Promise<Dict>;
    contractPrivateGetOrderListCloseOrders (params?: {}): Promise<Dict>;
    contractPrivateGetPlanorderListOrders (params?: {}): Promise<Dict>;
    contractPrivateGetStoporderListOrders (params?: {}): Promise<Dict>;
    contractPrivateGetStoporderOpenOrders (params?: {}): Promise<Dict>;
    contractPrivateGetStoporderOrderDetailsStopOrderId (params?: {}): Promise<Dict>;
    contractPrivateGetAccountRiskLimit (params?: {}): Promise<Dict>;
    contractPrivateGetAccountTieredFeeRate (params?: {}): Promise<Dict>;
    contractPrivateGetPositionLeverage (params?: {}): Promise<Dict>;
    contractPrivateGetAccountTieredFeeRateV2 (params?: {}): Promise<Dict>;
    contractPrivateGetTrackorderListOrders (params?: {}): Promise<Dict>;
    contractPrivateGetMarketMakerSelfTradeBlacklist (params?: {}): Promise<Dict>;
    contractPrivateGetMarketMakerSelfTradeBlacklistSearch (params?: {}): Promise<Dict>;
    contractPrivatePostAccountAssetAnalysisV3 (params?: {}): Promise<Dict>;
    contractPrivatePostAccountAssetAnalysisCalendarDailyV3 (params?: {}): Promise<Dict>;
    contractPrivatePostAccountAssetAnalysisCalendarMonthlyV3 (params?: {}): Promise<Dict>;
    contractPrivatePostAccountAssetAnalysisRecentV3 (params?: {}): Promise<Dict>;
    contractPrivatePostPositionChangeMargin (params?: {}): Promise<Dict>;
    contractPrivatePostPositionChangeAutoAddIm (params?: {}): Promise<Dict>;
    contractPrivatePostPositionChangeLeverage (params?: {}): Promise<Dict>;
    contractPrivatePostPositionChangePositionMode (params?: {}): Promise<Dict>;
    contractPrivatePostPositionReverse (params?: {}): Promise<Dict>;
    contractPrivatePostPositionCloseAll (params?: {}): Promise<Dict>;
    contractPrivatePostOrderCreate (params?: {}): Promise<Dict>;
    contractPrivatePostOrderSubmit (params?: {}): Promise<Dict>;
    contractPrivatePostOrderSubmitBatch (params?: {}): Promise<Dict>;
    contractPrivatePostOrderChaseLimitOrder (params?: {}): Promise<Dict>;
    contractPrivatePostOrderChangeLimitOrder (params?: {}): Promise<Dict>;
    contractPrivatePostOrderCancel (params?: {}): Promise<Dict>;
    contractPrivatePostOrderBatchCancelWithExternal (params?: {}): Promise<Dict>;
    contractPrivatePostOrderCancelWithExternal (params?: {}): Promise<Dict>;
    contractPrivatePostOrderCancelAll (params?: {}): Promise<Dict>;
    contractPrivatePostOrderOpenOrderTotalCount (params?: {}): Promise<Dict>;
    contractPrivatePostOrderBatchQueryWithExternal (params?: {}): Promise<Dict>;
    contractPrivatePostAccountChangeRiskLevel (params?: {}): Promise<Dict>;
    contractPrivatePostPlanorderPlace (params?: {}): Promise<Dict>;
    contractPrivatePostPlanorderPlaceV2 (params?: {}): Promise<Dict>;
    contractPrivatePostPlanorderCancel (params?: {}): Promise<Dict>;
    contractPrivatePostPlanorderCancelAll (params?: {}): Promise<Dict>;
    contractPrivatePostPlanorderChangeStopOrder (params?: {}): Promise<Dict>;
    contractPrivatePostStoporderPlace (params?: {}): Promise<Dict>;
    contractPrivatePostStoporderCancel (params?: {}): Promise<Dict>;
    contractPrivatePostStoporderCancelAll (params?: {}): Promise<Dict>;
    contractPrivatePostStoporderChangePrice (params?: {}): Promise<Dict>;
    contractPrivatePostStoporderChangePlanPrice (params?: {}): Promise<Dict>;
    contractPrivatePostTrackorderPlace (params?: {}): Promise<Dict>;
    contractPrivatePostTrackorderCancel (params?: {}): Promise<Dict>;
    contractPrivatePostTrackorderChangeOrder (params?: {}): Promise<Dict>;
    contractPrivatePostMarketMakerSelfTradeBlacklistCreate (params?: {}): Promise<Dict>;
    contractPrivatePostMarketMakerSelfTradeBlacklistUpdate (params?: {}): Promise<Dict>;
    contractPrivatePostMarketMakerSelfTradeBlacklistDelete (params?: {}): Promise<Dict>;
    spot2PublicGetMarketSymbols (params?: {}): Promise<Dict>;
    spot2PublicGetMarketCoinList (params?: {}): Promise<Dict>;
    spot2PublicGetCommonTimestamp (params?: {}): Promise<Dict>;
    spot2PublicGetCommonPing (params?: {}): Promise<Dict>;
    spot2PublicGetMarketTicker (params?: {}): Promise<Dict>;
    spot2PublicGetMarketDepth (params?: {}): Promise<Dict>;
    spot2PublicGetMarketDeals (params?: {}): Promise<Dict>;
    spot2PublicGetMarketKline (params?: {}): Promise<Dict>;
    spot2PublicGetMarketApiDefaultSymbols (params?: {}): Promise<Dict>;
    spot2PrivateGetAccountInfo (params?: {}): Promise<Dict>;
    spot2PrivateGetOrderOpenOrders (params?: {}): Promise<Dict>;
    spot2PrivateGetOrderList (params?: {}): Promise<Dict>;
    spot2PrivateGetOrderQuery (params?: {}): Promise<Dict>;
    spot2PrivateGetOrderDeals (params?: {}): Promise<Dict>;
    spot2PrivateGetOrderDealDetail (params?: {}): Promise<Dict>;
    spot2PrivateGetAssetDepositAddressList (params?: {}): Promise<Dict>;
    spot2PrivateGetAssetDepositList (params?: {}): Promise<Dict>;
    spot2PrivateGetAssetAddressList (params?: {}): Promise<Dict>;
    spot2PrivateGetAssetWithdrawList (params?: {}): Promise<Dict>;
    spot2PrivateGetAssetInternalTransferRecord (params?: {}): Promise<Dict>;
    spot2PrivateGetAccountBalance (params?: {}): Promise<Dict>;
    spot2PrivateGetAssetInternalTransferInfo (params?: {}): Promise<Dict>;
    spot2PrivateGetMarketApiSymbols (params?: {}): Promise<Dict>;
    spot2PrivatePostOrderPlace (params?: {}): Promise<Dict>;
    spot2PrivatePostOrderPlaceBatch (params?: {}): Promise<Dict>;
    spot2PrivatePostOrderAdvancedPlaceBatch (params?: {}): Promise<Dict>;
    spot2PrivatePostAssetWithdraw (params?: {}): Promise<Dict>;
    spot2PrivatePostAssetInternalTransfer (params?: {}): Promise<Dict>;
    spot2PrivateDeleteOrderCancel (params?: {}): Promise<Dict>;
    spot2PrivateDeleteOrderCancelBySymbol (params?: {}): Promise<Dict>;
    spot2PrivateDeleteAssetWithdraw (params?: {}): Promise<Dict>;
    brokerPrivateGetSubAccountUniversalTransfer (params?: {}): Promise<List>;
    brokerPrivateGetSubAccountList (params?: {}): Promise<Dict>;
    brokerPrivateGetSubAccountStatus (params?: {}): Promise<Dict>;
    brokerPrivateGetSubAccountApiKey (params?: {}): Promise<Dict>;
    brokerPrivateGetCapitalDepositSubAddress (params?: {}): Promise<List>;
    brokerPrivateGetCapitalDepositSubHisrec (params?: {}): Promise<List>;
    brokerPrivateGetCapitalDepositSubHisrecGetall (params?: {}): Promise<List>;
    brokerPrivateGetRebateTaxQuery (params?: {}): Promise<Dict>;
    brokerPrivatePostSubAccountVirtualSubAccount (params?: {}): Promise<Dict>;
    brokerPrivatePostSubAccountApiKey (params?: {}): Promise<Dict>;
    brokerPrivatePostCapitalDepositSubAddress (params?: {}): Promise<Dict>;
    brokerPrivatePostCapitalWithdrawApply (params?: {}): Promise<Dict>;
    brokerPrivatePostSubAccountUniversalTransfer (params?: {}): Promise<Dict>;
    brokerPrivatePostSubAccountFutures (params?: {}): Promise<Dict>;
    brokerPrivateDeleteSubAccountApiKey (params?: {}): Promise<Dict>;
}
abstract class Exchange extends _Exchange {}

export default Exchange
